import { render, staticRenderFns } from "./play_sound.vue?vue&type=template&id=34be27a9"
import script from "./play_sound.vue?vue&type=script&lang=js"
export * from "./play_sound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports